import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { Alert, Container, Form } from 'react-bootstrap';
import { ActionButtons, SectionHeader } from '../../common/components';
import { useAppDispatch } from '../../app/hooks';

function AddCustomer() {
  const backLinkUrl = '/customers/search';
  const dispatch = useAppDispatch();

  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
  };

  return (
    <>
      <Helmet>
        <title>Asiakkaat - Uusi asiakas</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Asiakkaat ja ryhmät', 'Asiakkaat']}
          Title="Uusi asiakas"
        />

        <Container className="container-form mt-48">
          {submitted ? (
            <Alert variant="success">Tiedot tallennettu!</Alert>
          ) : (
            <Form>
              <Form.Group className="mb-40">
                <Form.Label className="required" htmlFor="customerNumberTitle">
                  Asiakkaan tunniste
                </Form.Label>
              </Form.Group>
            </Form>
          )}
        </Container>
      </Container>
    </>
  );
}
export default AddCustomer;
